<template>
  <div class="v-time__wrapper">
    <i class="fal fa-clock"></i>
    <span v-if="time && time.isValid()"> {{ time.format(format) }} </span>
    <span v-else> N/A </span>
  </div>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";
import moment from "moment";

  export default Vue.component("VTime", {
  props: {
    startTime: VueTypes.any.isRequired,
    live: VueTypes.bool.def(true),
    format: VueTypes.string.def("LT")
  },

  data() {
    return {
      time: this._momentize(this.startTime),
      prevTime: this.startTime
    };
  },

  methods: {
    _momentize(time) {
      if (!time) {
        return null
      }

      return time && time instanceof moment ? time : moment(time);
    },

    updateTime() {
      this.time = moment(this.time.add(1, "s"));
    }
  },

  mounted() {
    if (this.live && this.time && this.time.isValid()) {
      this.interval = setInterval(this.updateTime, 1000);
    }
  },

  destroyed() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  },

  watch: {
    startTime: function(val) {
      if (this.prevTime !== val) {
        this.time = this._momentize(val)
      }
    }
  }
});
</script>

<style lang="scss" scoped>
i {
  color: $secondary-text-color;
}
</style>
